export const EINS_HEADER = [
  { label: 'Email Address', key: 'Email Address' },
  { label: 'Employer Key', key: 'Employer Key' },
  { label: 'Job Title', key: 'Job Title' },
  { label: 'Eins', key: 'Eins' },
  { label: 'DOH', key: 'DOH' },
  { label: 'Time Type', key: 'Time Type' },
  { label: 'Weekly Hours', key: 'Weekly Hours' },
  { label: 'Location', key: 'Location' },
]

export const EINS_DATA = [
  {
    "Email Address": 'Required',
    "Employer Key": 'Required',
    "Job Title": 'Optional',
    Eins: 'Required',
    DOH: 'Optional (but required for auto sign)',
    "Time Type": 'Optional (but required for auto sign)',
    "Weekly Hours": 'Optional (but required for auto sign)',
    Location: 'Optional',
  },
]